import { render, staticRenderFns } from "./coCurricuralActivities.vue?vue&type=template&id=3306187d&"
import script from "./coCurricuralActivities.vue?vue&type=script&lang=js&"
export * from "./coCurricuralActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports